import { api } from '../services/api';

/**
 * Tarih aralığındaki vakaların tamamlama belgelerini ZIP olarak indirir.
 * @param {'hospitals'|'institutions'} orgType
 * @returns {Promise<void>} hata durumunda sunucunun mesajıyla Error fırlatır
 */
export async function downloadCompletionDocumentsZip(orgType, orgId, orgName, startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);

  let response;
  try {
    response = await api.get(`/${orgType}/${orgId}/completion-documents-zip?${params}`, {
      responseType: 'blob',
      timeout: 600000, // yüzlerce fotoğraf indirilebilir
    });
  } catch (err) {
    // responseType blob olduğunda hata gövdesi de blob gelir
    let message = 'Belgeler indirilirken hata oluştu';
    try {
      const body = JSON.parse(await err.response?.data?.text());
      message = body.message || body.error || message;
    } catch { /* JSON değil */ }
    throw new Error(message);
  }

  const safeName = (orgName || 'kurum').replace(/[^a-z0-9]/gi, '_');
  const url = URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `tamamlama_belgeleri_${safeName}_${startDate || 'tum'}_${endDate || 'donem'}.zip`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
